import { intervalToDuration } from "date-fns";
import { TnAScheduleIntervalRef } from "../../../../../models/tna/tna-schedule-intervals/tna-schedule-interval-ref";

export const getIntervalDuration = (item: TnAScheduleIntervalRef): number => {
  const diff =
    (item.startHour <= item.endHour
      ? new Date(0, 0, 1, item.endHour, item.endMinute).getTime()
      : new Date(0, 0, 2, item.endHour, item.endMinute).getTime()) -
    new Date(0, 0, 1, item.startHour, item.startMinute).getTime();

  return diff;
};

export const getIntervalsDuration = (items: TnAScheduleIntervalRef[]): number => {
  let total = 0;

  items?.forEach((item) => {
    total += getIntervalDuration(item);
  });

  return total;
};

export const intervalAsDuration = (diff: number): Duration => {
  const dur = intervalToDuration({ start: 0, end: diff });
  return dur;
};

export const zeroPad = (num: number) => String(num).padStart(2, "0");

// This takes into account only days, hours and minutes and returns as HH:MM string
export const formatDurationAsHours = (duration: Duration): string => {
  const hours = (duration?.days ?? 0) * 24 + (duration?.hours ?? 0);
  const str = `${zeroPad(hours)}:${zeroPad(duration?.minutes ?? 0)}`;
  return str;
};

export const formatDurationAsYearsMonthsDays = (duration: Duration): string => {
  const years = duration?.years ?? 0;
  const months = duration?.months ?? 0;
  const days = (duration?.days ?? 0) + 1;
  const str = `${years > 0 ? `${years}y` : ""} ${months > 0 ? `${months}m` : ""} ${days > 0 ? `${days}d` : ""}`;
  return str;
};

export const formatIntervalsDuration = (items: TnAScheduleIntervalRef[]): string => {
  return formatDurationAsHours(intervalAsDuration(getIntervalsDuration(items)));
};
